import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { NavController } from "@ionic/angular";
import { ReturnNativeService } from "../../../../app/shared/service/comunicator-native/return-native/return-native";
import { AnalyticsPageModel } from "../../../shared/model/analyticsPage";
import { DefaultPageComponent } from "../../../shared/page/default-page.component";
import { AnalyticsGA4PageService } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-page.service";
import { AnalyticsGA4PagesModel } from "../../../shared/service/analytics-ga4-pages/analytics-ga4-pages-models";
import { AnalyticsPageService } from "../../../shared/service/analytics/analytics-page.service";
import { AnalycticsNativeService } from "../../../shared/service/comunicator-native/analytics-native/analyctics-native";
import { BackNativeService } from "../../../shared/service/comunicator-native/back-native/back-native";
import { DomainFactoryService } from "../../../shared/service/domains/domain-factory-service";
import { DomainDataType } from "../../../shared/service/domains/model/domain-data-type";
import { JourneyService } from "../../../shared/service/journey/journey.service";
import { TrackTypes } from "../../../shared/service/journey/tracks/model/track-types";
import { RadioModel } from "../../model/radio.model";
import { PersonalDataService } from "../../service/personal-data.service";

declare global {
  interface Window {
    focusHeaderWebview: (focus: string) => any;
  }
}

@Component({
  selector: "app-gender",
  templateUrl: "./gender.component.html",
  styleUrls: ["./gender.component.scss"],
})
export class GenderComponent extends DefaultPageComponent implements OnInit {
  headerId = "gender";
  public selectedItem: string;
  public selectedItemCode: string;
  selectedName = "";
  buttonEnable = false;
  public genderType = new Array<RadioModel>();
  textAria = "";
  idLabel = "page-gender";
  titlePage = "Dados pessoais";
  startStage = "";
  endStage = "";
  showRetry = false;
  loading = true;
  dataDomain: RadioModel[];
  analyticsPage: AnalyticsPageModel;
  analyticsPageGA4: AnalyticsGA4PagesModel;
  sendAnalyticsFirstView = false;
  idLabelGender = "idLabelGender";
  idRadioGender = "idRadioGender";
  idButtonGender = "idButtonGender";

  constructor(
    public router: NavController,
    private personalDataService: PersonalDataService,
    public backNativeService: BackNativeService,
    public journeyService: JourneyService,
    private title: Title,
    public returnNativeService: ReturnNativeService,
    public analycticsNativeService: AnalycticsNativeService,
    public domainFactory: DomainFactoryService,
    private analyticsPageService: AnalyticsPageService,
    private analyticsGA4PageService: AnalyticsGA4PageService
  ) {
    super(backNativeService, journeyService, router, returnNativeService);
    this.getAnalyticsPage();
    this.getAnalyticsPageGA4();
    this.configureDomain(null, DomainDataType.Gender);
    this.getTrack();
  }

  ngOnInit() {
    this.setTitle();
    this.headerFocus();
    this.getGenderType();
    this.editFieldInvest("genero_codigo", "gender", "personalData");
  }

  getAnalyticsPage() {
    this.analyticsPage = this.analyticsPageService.setAnalyticsPage();
  }

  getAnalyticsPageGA4() {
    this.analyticsPageGA4 = this.analyticsGA4PageService.setAnalyticsPageGA4();
  }

  getTrack() {
    const track = this.journeyService.selectedTrack;
    const path = "personal-data";

    if (
      this.journeyService.journey === TrackTypes.CONTA_ION ||
      this.journeyService.journey === TrackTypes.CONTA_ION_PERSONAL
    ) {
      this.startStage = "11";
      this.endStage = "11";
    } else {
      this.startStage = (
        track.getIndexPage(this.headerId, path) - 1
      ).toString();
      this.endStage = (track.getTotalPage(path) - 1).toString();
    }
  }

  analyticsData() {
    const it_pagename = this.analyticsPage.gender;
    this.analycticsNativeService.analyticsTrackStateCommunicator(it_pagename);
  }

  sendTrackGA4LoadPage() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameScreenView,
      custom_path: this.analyticsPageGA4.customPathGenero,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl);
  }

  sendTrackGA4LoadPageError() {
    const paramDefautl = {
      event_name: this.analyticsPageGA4.eventNameAlert,
      custom_path: this.analyticsPageGA4.customPathGenero,
      implementation_team: this.analyticsPageGA4.implementationTeam,
    };
    const paramComplementary = {
      detail: "tipo:tela",
      description: this.analyticsPageGA4.titleError,
    };

    this.analyticsGA4PageService.sendTrackGA4(paramDefautl, paramComplementary);
  }

  /* istanbul ignore next */
  ionViewWillEnter() {
    this.headerFocus();
    this.setEditPageRegistratio();

    if (this.sendAnalyticsFirstView) {
      this.analyticsData();
      this.sendTrackGA4LoadPage();
    }
  }

  ionViewDidLeave() {
    this.ariaHidden = true;
  }

  setTitle() {
    this.title.setTitle(this.titlePage);
  }

  changeItem(event) {
    if (event) {
      this.buttonEnable = true;
    } else {
      this.buttonEnable = false;
    }
  }

  public clickNext() {
    this.sendAnalyticsFirstView = true;
    this.personalDataService.setGenderTypeNameData(
      this.selectedName,
      this.selectedItemCode
    );
    this.personalDataService.setGenderTypeData(this.selectedItem);
    this.nextPage();
  }

  analyticsEventClique() {
    const it_eventcategory = "Clique";
    const it_complementary = {
      it_eventaction: this.analyticsPage.action,
      it_eventlabel: this.analyticsPage.back,
      it_pagename: this.analyticsPage.gender,
    };
    this.analycticsNativeService.analyticsTrackActionCommunicator(
      it_eventcategory,
      it_complementary
    );
  }

  getPageId(): string {
    return this.headerId;
  }

  getGenderType() {
    this.domainFactory
      .getDomainService(this.domainOrigin)
      .getDomains(this.domainDataType)
      .then((dominios) => {
        if (dominios?.length > 0) {
          this.genderType = dominios;
          this.showRetry = false;
          this.analyticsData();
          this.sendTrackGA4LoadPage();
        } else {
          this.showRetry = true;
          this.headerFocus();
          this.sendTrackGA4LoadPageError();
        }
      })
      .catch(() => {
        this.showRetry = true;
        this.sendTrackGA4LoadPageError();
      })
      .finally(() => {
        this.loading = false;
        this.headerFocus();
      });
  }

  setEditPageRegistratio() {
    if (this.journeyService.registratioJourney.data.personalData.gender) {
      this.selectedItem =
        this.journeyService.registratioJourney.data.personalData.gender;
      this.selectedName =
        this.journeyService.registratioJourney.data.personalData.genderName;
      this.selectedItemCode =
        this.journeyService.registratioJourney.data.personalData?.genderCode;
      this.buttonEnable = true;
    }
  }

  backPage() {
    this.analyticsEventClique();
    this.back();
  }
}
